export default __webpack_public_path__ + "static/media/subscription-paused.4258a836.svg";